'use client'

import dynamic from 'next/dynamic'

const ScrollReset = dynamic(
  async () => (await import('./scroll-reset')).ScrollReset,
  {
    ssr: false,
  },
)

export const ScrollResetClient = () => {
  return <ScrollReset />
}
